var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalNomad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 960,
    viewBox: "0 0 960 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_1695)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.038 581.771C557.35 574.262 559.39 566.925 563 560.332C565.675 555.532 569.169 551.19 572.651 546.863C577.802 540.462 582.925 534.095 585.329 526.33C589.287 513.46 584.522 498.878 575.179 489.202C565.836 479.526 552.508 474.369 539.136 472.859C527.615 471.626 515.964 472.893 504.978 476.573C493.992 480.254 483.929 486.261 475.477 494.186C467.134 502.229 460.669 512.015 456.546 522.845C452.423 533.676 450.743 545.283 451.625 556.838C452.118 562.575 453.25 568.22 454.382 573.868C455.093 577.413 455.804 580.96 456.357 584.531C457.792 593.791 458.101 603.535 454.657 612.253L454.986 612.863C467.927 605.969 481.464 600.256 495.432 595.794L495.964 597.41C498.483 596.636 501.107 596.254 503.743 596.278C505.011 596.249 506.279 596.278 507.527 596.326L508.543 596.317C508.28 574.741 506.59 553.207 503.482 531.855L502.011 531.719C514.833 529.16 526.281 522.014 534.211 511.619L534.27 511.658C540.105 515.581 546.755 518.128 553.718 519.108L553.68 519.398C555.584 535.44 552.063 551.657 543.68 565.466C541.896 568.386 539.907 571.174 537.919 573.96C535.498 577.352 533.079 580.742 531.034 584.366C528.32 588.919 526.627 594.006 526.07 599.277L527.55 599.364C528.696 599.407 529.844 599.448 530.993 599.489C532.153 599.53 533.313 599.571 534.469 599.615C538.602 599.774 542.736 599.925 546.869 600.07L546.947 599.122C551.258 600.204 555.418 601.817 559.332 603.922L561.2 603.632C558.15 596.762 556.726 589.281 557.038 581.771ZM563.429 487.624C562.722 487.246 561.842 487.513 561.464 488.22C561.086 488.927 561.353 489.806 562.06 490.184C574.329 496.747 581.117 512.243 577.624 525.711C577.423 526.487 577.889 527.279 578.665 527.48C579.441 527.682 580.233 527.216 580.434 526.44C584.263 511.674 576.88 494.82 563.429 487.624Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.2 179.588C425.168 366.23 383.7 620.711 359.487 808.882L359.671 810.61C372.081 809.31 384.553 808.706 397.03 808.8V808.055C397.26 789.121 397.911 769.955 398.985 750.555L399.478 750.245C390.837 736.185 386.836 719.764 388.041 703.306C389.425 685 396.759 667.65 407.655 652.778C429.175 473.673 459.219 343.636 525.21 187.29L525.239 187.222C511.509 180.546 493.899 175.417 472.253 173.056C467.62 174.588 463.095 176.427 458.707 178.562L459.2 179.588ZM503.33 212.947C503.58 212.186 503.166 211.366 502.404 211.115C501.643 210.865 500.822 211.279 500.572 212.041C471.491 300.521 445.788 390.018 423.465 480.531C423.273 481.309 423.748 482.095 424.526 482.287C425.305 482.479 426.091 482.004 426.283 481.226C448.589 390.784 474.271 301.358 503.33 212.947Z",
    fill: "url(#paint0_linear_248_1695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.91 851.776C713.061 855.037 711.832 858.801 709.51 861.365C707.062 863.828 704.013 865.609 700.666 866.532C689.103 870.296 676.36 868.884 664.874 864.926C653.388 860.968 642.9 854.592 632.527 848.264L631.385 848C632.647 841.909 633.308 835.709 633.359 829.489C645.626 834.197 658.982 835.307 671.859 832.689C676.349 831.76 680.945 830.241 684.506 827.474L685.241 828.374C692.307 834.041 699.368 839.707 706.422 845.374C708.649 847.171 710.971 849.1 711.91 851.776Z",
    fill: "url(#paint1_linear_248_1695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.456 894.448C658.739 901.908 653.127 909.63 646.548 913.819C635.817 920.651 622.183 921.764 609.72 919.219C597.257 916.674 585.743 910.771 574.77 904.347C569.613 901.328 564.427 898.076 560.711 893.403C556.995 888.73 554.944 882.303 556.899 876.663L557.099 876.199C560.32 877.589 563.67 878.661 567.099 879.399C578.352 881.934 590.263 882.34 601.304 879.021C608.256 876.956 614.637 873.314 619.95 868.378L621.788 868.619C629.432 873.293 637.08 877.963 644.73 882.63C649.586 885.594 654.8 889.02 656.456 894.448Z",
    fill: "url(#paint2_linear_248_1695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.925 93.1901C605.656 97.6601 592.894 106.059 587.825 121.154L587.864 121.86C566.367 122.963 545.173 127.413 525.047 135.049L523.747 136.5C514.886 128.639 505.349 121.574 495.247 115.387C567.494 45.0221 681.469 21.2381 775.82 56.8461C748.668 70.4112 725.144 90.2578 707.2 114.738C699.851 99.7593 688.36 87.203 674.089 78.5591C671.389 86.4157 668.686 94.2697 665.98 102.121C659.711 97.1767 652.359 93.7893 644.527 92.2368C636.695 90.6843 628.606 91.011 620.925 93.1901V93.1901Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.339 774.58C424.82 773.874 423.33 773.1 421.869 772.258C412.706 766.877 405.015 759.315 399.478 750.245C390.837 736.186 386.836 719.765 388.041 703.306C389.425 684.999 396.759 667.65 407.654 652.778C412.799 645.77 418.669 639.325 425.168 633.551C434.279 625.539 444.277 618.599 454.968 612.864C467.91 605.97 481.447 600.257 495.414 595.795L495.946 597.411C494.701 597.813 493.516 598.382 492.424 599.104C488.124 601.959 485.805 607.29 485.979 612.448C486.302 617.649 488.491 622.559 492.143 626.275C495.786 629.954 500.17 632.818 505.003 634.675C510.603 636.987 516.74 638.39 522.739 637.558C530.925 636.416 538.239 631.066 542.478 623.973C546.615 616.737 548.161 608.306 546.861 600.073L546.939 599.125C551.25 600.208 555.41 601.82 559.324 603.925C562.803 605.683 566.179 607.638 569.436 609.779L569.465 610.215L560.543 610.737L539.179 694.048C526.164 710.469 516.091 729.579 506.379 748.302L506.495 748.37C498.551 762.778 485.633 773.789 469.795 778.25C455.334 782.227 439.929 780.926 426.339 774.58V774.58Z",
    fill: "url(#paint3_linear_248_1695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.9 549.4C533.103 549.886 534.43 549.967 535.683 549.633C536.302 549.454 536.848 549.083 537.241 548.573C537.634 548.063 537.855 547.441 537.87 546.797C537.851 546.483 537.759 546.178 537.602 545.905C537.446 545.632 537.229 545.399 536.968 545.223C536.707 545.047 536.409 544.934 536.098 544.891C535.786 544.849 535.469 544.879 535.17 544.978",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.945 533.394C521.833 532.565 520.486 532.113 519.099 532.102C517.712 532.092 516.358 532.524 515.233 533.336",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.75 533.065C538.975 532.333 540.377 531.949 541.804 531.954C543.231 531.959 544.63 532.353 545.85 533.094",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.056 524.753C537.871 523.453 540.055 522.771 542.288 522.805C544.52 522.84 546.682 523.591 548.456 524.947",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.7 532.368C499.142 532.214 500.574 531.991 502 531.72C514.822 529.162 526.27 522.015 534.2 511.62C534.84 510.778 535.449 509.917 536.029 509.036",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.257 511.662C540.092 515.585 546.742 518.132 553.705 519.112C557.407 519.641 561.16 519.716 564.881 519.335",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.512 596.327C506.264 596.279 504.996 596.25 503.728 596.279C501.092 596.255 498.468 596.637 495.949 597.411C494.703 597.813 493.519 598.383 492.427 599.104C488.127 601.959 485.808 607.29 485.982 612.448C486.305 617.649 488.493 622.559 492.146 626.275C495.789 629.955 500.172 632.818 505.006 634.675C510.606 636.987 516.743 638.39 522.742 637.558C530.928 636.416 538.242 631.066 542.481 623.973C546.618 616.737 548.164 608.306 546.864 600.073C542.73 599.928 538.597 599.777 534.464 599.618C532.164 599.531 529.848 599.454 527.545 599.367",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.942 599.124C551.253 600.207 555.413 601.819 559.327 603.924C562.806 605.682 566.182 607.637 569.439 609.778",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.065 595.582C495.852 595.65 495.63 595.727 495.417 595.795C481.45 600.258 467.913 605.97 454.971 612.864C444.28 618.599 434.282 625.54 425.171 633.551C418.672 639.325 412.802 645.77 407.657 652.778C396.759 667.65 389.425 685 388.041 703.306C386.836 719.765 390.837 736.186 399.478 750.245C405.015 759.315 412.706 766.877 421.869 772.258C423.33 773.1 424.82 773.874 426.339 774.58C439.929 780.925 455.333 782.226 469.794 778.248C485.634 773.787 498.552 762.776 506.494 748.368L506.61 748.168",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.07 697.172C443.57 706.625 456.093 710.331 467.54 709.557C478.987 708.783 489.805 704.293 500.603 700.403C511.401 696.513 522.829 693.137 534.198 694.675",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.467 531.856C506.574 553.208 508.265 574.742 508.528 596.318C508.557 599.085 508.566 601.843 508.557 604.61",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.667 519.4C555.571 535.442 552.051 551.659 543.667 565.468C539.71 571.942 534.746 577.768 531.021 584.368C528.308 588.921 526.614 594.008 526.057 599.279C525.867 601.576 526.027 603.889 526.531 606.139",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.728 596.4C501.918 597.609 500.448 599.261 499.457 601.198C498.467 603.136 497.988 605.295 498.068 607.47C498.311 611.85 500.281 615.956 503.545 618.887C506.808 621.778 510.8 623.723 515.088 624.509C519.696 625.552 524.51 625.184 528.906 623.455C531.087 622.573 533.047 621.222 534.647 619.498C536.248 617.774 537.449 615.718 538.166 613.478C538.834 611.222 538.836 608.82 538.172 606.563C537.508 604.306 536.205 602.288 534.421 600.754",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.209 567.067C524.279 567.367 523.291 567.446 522.325 567.297C521.359 567.148 520.441 566.777 519.643 566.211C518.846 565.646 518.191 564.902 517.732 564.04C517.272 563.177 517.019 562.219 516.994 561.242",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.2 603.633C558.15 596.763 556.726 589.282 557.038 581.772C557.35 574.263 559.391 566.926 563 560.333C569.637 548.433 581.307 539.346 585.322 526.333C589.28 513.463 584.529 498.881 575.172 489.205C565.815 479.529 552.5 474.37 539.124 472.86C527.604 471.627 515.953 472.894 504.967 476.574C493.98 480.255 483.918 486.262 475.465 494.187C467.122 502.23 460.658 512.016 456.535 522.846C452.411 533.677 450.731 545.284 451.613 556.839C452.413 566.177 454.913 575.272 456.345 584.532C457.777 593.792 458.086 603.532 454.645 612.254",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.38 748.3C516.094 729.577 526.167 710.467 539.18 694.046C545.721 685.637 553.263 678.057 561.638 671.472C569.882 665.086 579.732 659.696 590.144 660.354C600.644 661.022 610.009 667.911 615.921 676.61C617.799 679.385 619.418 682.326 620.759 685.396C623.534 692.013 625.625 698.896 627 705.938C635.428 745.165 634.46 785.718 633.464 825.815C633.435 827.035 633.405 828.263 633.357 829.492C633.307 835.711 632.646 841.91 631.385 848C630.593 851.518 629.368 854.924 627.737 858.14C625.742 861.969 623.112 865.431 619.958 868.378C614.645 873.314 608.264 876.956 601.312 879.021C590.271 882.34 578.36 881.934 567.107 879.399C563.677 878.661 560.328 877.589 557.107 876.199C552.606 874.366 548.697 871.33 545.807 867.423C541.927 861.869 541.017 854.823 540.359 848.08C540.011 844.5 539.705 840.914 539.44 837.32C537.35 809.143 537.969 780.686 543.504 753.012",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 775.306C423.1 785.534 425.952 796.536 430.306 806.221C439.566 826.783 456.451 844.521 477.864 851.592C499.016 858.579 524.426 853.721 539.433 837.32C539.627 837.127 539.801 836.92 539.985 836.72",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.158 685.222C624.147 678.245 627.795 671.395 633.185 666.044C638.575 660.693 645.938 656.977 653.524 657.306C659.193 657.689 664.568 659.969 668.783 663.779C671.929 666.507 674.574 669.763 676.6 673.4C681.38 681.953 683.092 691.823 684.65 701.5C690.34 736.914 694.878 772.832 692.101 808.6C691.675 814.106 690.959 819.9 687.64 824.324C686.743 825.515 685.688 826.58 684.505 827.488C680.944 830.255 676.348 831.774 671.858 832.703C658.982 835.321 645.626 834.21 633.358 829.503C633.194 829.445 633.039 829.387 632.874 829.319",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.9 876.663C554.945 882.304 556.987 888.729 560.712 893.403C564.437 898.077 569.612 901.328 574.771 904.347C585.744 910.771 597.259 916.674 609.721 919.219C622.183 921.764 635.821 920.651 646.549 913.819C653.128 909.63 658.74 901.908 656.457 894.448C654.802 889.02 649.587 885.594 644.739 882.633C637.095 877.96 629.447 873.289 621.797 868.622",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.527 848.264C642.9 854.592 653.379 860.959 664.874 864.926C676.369 868.893 689.103 870.296 700.666 866.532C704.014 865.609 707.063 863.828 709.51 861.365C711.832 858.801 713.061 855.037 711.91 851.776C710.971 849.096 708.649 847.176 706.423 845.376C699.361 839.709 692.3 834.043 685.242 828.376",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.114 694.298L539.182 694.046L560.546 610.735L569.468 610.213L692.944 602.994L668.783 663.779",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.985 750.555C397.911 769.955 397.26 789.122 397.03 808.055",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.209 187.29C459.218 343.636 429.174 473.673 407.654 652.778",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.063 809.279C407.722 808.979 402.378 808.818 397.03 808.795C371.441 808.61 345.915 811.346 320.947 816.952",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.2 179.588C425.169 366.23 383.7 620.711 359.488 808.882",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.045 135.049C545.171 127.412 566.364 122.963 587.862 121.86C657.307 118.183 728.64 148.082 774.5 204C834.482 277.142 847.042 390.091 804.748 476.083C800.577 431.592 768.579 396.564 738.408 365.417C745.443 355.915 752.481 346.415 759.522 336.917C748.626 329.747 737.731 322.583 726.836 315.426C733.957 299.219 733.029 279.896 726.971 263.204C720.913 246.512 710.145 232.173 698.117 219.662C662.3 182.532 613.863 160.18 562.371 157.019",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.547 154.73C543.876 154.495 553.201 155.336 562.337 157.236C594.132 163.787 623.509 182.461 644.748 207.348C672.073 239.357 686.878 280.664 692.432 322.387C697.986 364.11 694.793 406.502 689.519 448.264C658.801 407.509 623.277 370.609 583.719 338.364C589.031 321.082 594.34 303.804 599.646 286.529C587.534 285.39 575.834 281.54 565.412 275.266C568.255 264.983 568.979 254.229 567.54 243.657C566.102 233.085 562.53 222.916 557.042 213.766C551.197 204.138 540.67 194.713 525.236 187.224C511.506 180.548 493.896 175.419 472.25 173.058",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.951 150.743C453.084 149.662 448.112 149.126 443.127 149.143C424.384 149.172 405.642 156.643 390.663 168.214C371.717 182.844 358.171 203.426 347.643 224.926C314.667 292.262 309.161 372.564 332.655 443.77C355.249 426.218 377.839 408.662 400.426 391.103C393.411 374.97 386.399 358.843 379.391 342.723C388.127 339.856 396.868 336.995 405.613 334.14C398.719 320.469 394.624 305.559 393.567 290.285C392.51 275.011 394.512 259.68 399.457 245.189C404.402 230.699 412.19 217.342 422.364 205.9C432.537 194.458 444.893 185.163 458.706 178.558C463.094 176.423 467.619 174.584 472.252 173.052",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.583 144.87C529.728 141.986 526.783 139.196 523.748 136.5C514.887 128.639 505.35 121.574 495.248 115.387C450.012 87.6263 393.978 77.2243 342.027 88.5743C274.527 103.33 216.083 154.323 192.327 219.211C168.571 284.099 180.276 360.782 222.3 415.636C234.064 387.854 252.045 363.141 274.86 343.4C261.613 331.447 251.352 316.556 244.9 299.92C255.35 292.537 265.806 285.151 276.269 277.761C269.079 269.61 264.233 259.662 262.249 248.975C299.511 187.222 371.018 147.734 443.124 149.069",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.223 115.416L495.252 115.387C567.494 45.0221 681.469 21.2381 775.82 56.8461C748.668 70.4112 725.143 90.2578 707.2 114.738C699.851 99.7593 688.359 87.203 674.089 78.5591C671.389 86.4157 668.686 94.2697 665.98 102.121C659.711 97.1772 652.359 93.79 644.528 92.2375C636.696 90.6851 628.608 91.0115 620.928 93.1901C605.659 97.6601 592.897 106.059 587.828 121.154",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.432 438.388L592.544 425.4",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.314 439.061L603.9 424.615",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.177 367.216L549.152 355.03",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.822 364.483C549.422 361.434 553.211 358.616 557.167 356.047",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 587.3L649.633 515.468",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.573 589.919L658.598 574.249",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.2 584.435C610.776 578.811 609.286 572.828 608.79 566.724",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.938 546.477L731.223 538.905",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.241 550.983L721.726 531.874",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.937 614.515C743.687 609.231 743.002 603.977 741.888 598.806",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.109 610.528L751.092 606.928",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.171 424.553C200.161 418.57 194.61 409.87 192.558 400.085",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.822 478.918C829.961 469.241 834.156 458.462 836.174 447.181",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.973 247.194C482.724 230.682 468.088 210.574 457.984 188.133",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 297.084C466.991 284.362 454.545 267.716 446.871 248.763",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.488 344.458C454.972 333.432 444.996 319.822 438.249 304.568",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.363 387.979C443.886 378.488 434.954 366.288 429.375 352.479",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.873 434.556C434.052 426.592 426.247 416.427 421.089 404.883",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.352 483.808C424.06 476.85 416.673 467.661 411.874 457.091",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.243 533.407C416.293 526.197 409.469 517.835 404 508.6",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.58 591.8C407.015 584.79 400.5 576.726 395.236 567.857",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.457 638.429C399.734 634.115 392.398 627.438 387.283 619.159",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.133 676.3C387.673 673.252 382.992 668.983 379.455 663.826",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.816 719.855C382.055 717.513 377.101 713.545 373.559 708.434",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.885 768.84C385.325 765.357 375.279 758.074 368.375 748.17",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.884 657.2C534.156 654.726 535.896 652.523 538.007 650.711",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.586 646.617L490.196 641.836",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.147 616.223L487.199 616.594C490.778 615.427 494.195 613.811 497.368 611.785",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.3 628.483L502.394 620.248",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.715 635.348L514.446 625.103",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.051 635.038L525.297 626.158",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.043 624.795L535.985 619.272",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.4 610.076H545.181",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.1 715.26L519.223 709.46",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.366 741.557L479.95 735.068",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.027 728.875L461.48 724.791",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.164 754.876L430.09 748.387",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.966 720.042L418.137 717.993",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.558 692.718L418.144 686.57",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.528 656.7L426.675 656.721",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.257 656.866L459.524 647.643",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.023 682.636C468.306 681.813 465.432 681.651 462.641 682.163L463.899 681.793",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.432 679.4L494.946 671.213",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.934 678.313L528.791 678.583",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.451 617.946C473.606 618.048 473.721 618.202 473.774 618.38C473.827 618.558 473.815 618.75 473.741 618.92C471.944 617.748 469.779 617.274 467.656 617.589",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.218 879.3C562.531 881.724 563.657 884.373 565.433 886.162C567.314 887.846 569.481 889.179 571.833 890.099C578.553 893.181 585.315 896.171 592.119 899.069C601.347 902.999 610.834 906.802 620.833 907.598C633.405 908.543 645.871 904.703 655.733 896.847",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.476 840.872C640.564 843.057 649.047 847.172 657.603 850.934C666.159 854.696 675.023 858.166 684.338 858.934C693.653 859.702 703.595 857.434 710.363 850.984",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.2 839.053C692.385 840.556 687.929 843.034 684.112 846.332",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.2 831.934L675.56 839.1",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.9 883.028C638.142 884.599 632.767 887.333 628.106 891.061",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.511 874.353C623.972 876.574 619.055 880.104 615.179 884.641",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.505 293.423C553.987 292.611 548.347 281.602 552.665 274.214",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.345 83.4491C768.683 79.9551 775.034 74.6865 779.823 68.1201",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.337 157.236C594.132 163.787 623.509 182.461 644.748 207.348C672.073 239.357 686.878 280.664 692.432 322.387C697.986 364.11 694.793 406.502 689.519 448.264C658.801 407.509 623.277 370.609 583.719 338.364C589.031 321.082 594.34 303.803 599.646 286.529C587.534 285.39 575.834 281.54 565.412 275.266C568.255 264.982 568.979 254.228 567.54 243.657C566.102 233.085 562.53 222.915 557.042 213.766C551.197 204.138 540.67 194.713 525.236 187.224C511.506 180.548 493.896 175.419 472.25 173.058C467.617 174.59 463.092 176.429 458.704 178.564C444.891 185.169 432.536 194.464 422.362 205.906C412.188 217.348 404.4 230.705 399.456 245.195C394.511 259.685 392.508 275.017 393.565 290.291C394.622 305.565 398.717 320.475 405.611 334.146C396.873 337.012 388.132 339.873 379.389 342.729C386.394 358.862 393.405 374.989 400.424 391.109C377.831 408.661 355.241 426.217 332.653 443.776C309.159 372.57 314.665 292.268 347.641 224.932C358.169 203.432 371.715 182.85 390.661 168.22C405.64 156.648 424.382 149.178 443.125 149.149V149.071C371.019 147.736 299.512 187.224 262.25 248.977C264.234 259.663 269.08 269.612 276.27 277.763C265.813 285.145 255.356 292.53 244.9 299.92C251.352 316.555 261.613 331.447 274.86 343.4C252.045 363.141 234.064 387.854 222.3 415.636C180.277 360.782 168.569 284.099 192.333 219.211C216.097 154.323 274.533 103.33 342.033 88.5738C393.984 77.2238 450.018 87.6258 495.254 115.387C505.356 121.574 514.893 128.639 523.754 136.5L525.054 135.049C545.18 127.412 566.373 122.963 587.871 121.86C657.307 118.183 728.64 148.082 774.5 204C834.482 277.142 847.042 390.091 804.748 476.083C800.577 431.592 768.579 396.564 738.408 365.417C745.443 355.915 752.481 346.415 759.522 336.917C748.626 329.747 737.731 322.583 726.836 315.426C733.957 299.219 733.029 279.896 726.971 263.204C720.913 246.512 710.145 232.173 698.117 219.662C662.3 182.532 613.864 160.18 562.371 157.019L562.337 157.236ZM738.412 190.535C738.884 189.887 739.792 189.744 740.44 190.217C796.003 230.718 825.55 304.011 813.614 371.723C813.475 372.512 812.722 373.039 811.933 372.9C811.143 372.761 810.616 372.008 810.755 371.219C822.498 304.598 793.397 232.411 738.73 192.563C738.082 192.09 737.94 191.182 738.412 190.535ZM655.255 245.088C654.89 244.374 654.016 244.091 653.302 244.455C652.588 244.82 652.305 245.694 652.669 246.408C676.662 293.381 686.517 346.305 681.04 398.765C680.957 399.563 681.536 400.276 682.333 400.36C683.131 400.443 683.844 399.864 683.928 399.067C689.463 346.048 679.503 292.561 655.255 245.088ZM345.551 161.396C345.852 162.139 345.493 162.985 344.75 163.286C308.992 177.767 278.568 202.921 257.624 235.32C257.189 235.994 256.29 236.187 255.617 235.751C254.944 235.316 254.751 234.418 255.186 233.744C276.455 200.844 307.349 175.301 343.66 160.595C344.403 160.294 345.25 160.653 345.551 161.396ZM421.168 194.195C421.765 193.661 421.816 192.743 421.282 192.146C420.747 191.548 419.83 191.497 419.232 192.031C386.845 221.004 371.501 267.746 380.417 310.278C380.582 311.063 381.351 311.565 382.136 311.401C382.92 311.236 383.423 310.467 383.258 309.682C374.555 268.166 389.554 222.476 421.168 194.195Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M692.103 808.6C694.88 772.832 690.342 736.914 684.652 701.5C683.094 691.821 681.382 681.951 676.6 673.4C674.574 669.767 671.93 666.515 668.787 663.79C664.571 659.98 659.197 657.7 653.528 657.317C645.942 656.988 638.579 660.704 633.189 666.055C627.799 671.406 624.151 678.256 621.162 685.233L620.762 685.407C623.537 692.024 625.628 698.907 627.003 705.949C635.431 745.176 634.467 785.726 633.467 825.826C633.438 827.046 633.408 828.274 633.36 829.503C645.627 834.211 658.983 835.321 671.86 832.703C676.35 831.774 680.946 830.255 684.507 827.488C685.69 826.58 686.745 825.516 687.642 824.324C690.961 819.9 691.677 814.106 692.103 808.6ZM669.715 669.578C669.443 668.824 668.611 668.433 667.857 668.705C667.103 668.977 666.712 669.809 666.984 670.563C683.037 715.071 689.073 762.572 684.661 809.68C684.587 810.478 685.173 811.186 685.971 811.26C686.769 811.335 687.477 810.749 687.552 809.951C692.003 762.417 685.913 714.487 669.715 669.578Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.923 676.61C610.011 667.911 600.646 661.022 590.146 660.354C579.734 659.7 569.884 665.086 561.643 671.472C553.268 678.056 545.727 685.637 539.185 694.046C526.172 710.467 516.099 729.577 506.385 748.3L506.501 748.368C498.559 762.776 485.641 773.787 469.801 778.248C455.341 782.225 439.936 780.925 426.346 774.58L426.007 775.306C423.105 785.534 425.959 796.536 430.313 806.221C439.571 826.783 456.458 844.519 477.871 851.592C499.023 858.579 524.433 853.72 539.44 837.32C539.705 840.913 540.011 844.5 540.359 848.08C541.017 854.823 541.927 861.869 545.807 867.423C548.697 871.33 552.607 874.366 557.107 876.199C560.329 877.589 563.678 878.66 567.107 879.399C578.36 881.934 590.271 882.34 601.312 879.021C608.264 876.956 614.645 873.313 619.958 868.378C623.112 865.43 625.743 861.968 627.737 858.14C629.368 854.924 630.593 851.518 631.385 848C632.647 841.91 633.307 835.711 633.357 829.492C633.405 828.263 633.435 827.035 633.464 825.815C634.46 785.718 635.428 745.165 627 705.938C625.627 698.896 623.536 692.012 620.761 685.396C619.421 682.325 617.801 679.384 615.923 676.61ZM608.781 678.621C608.512 677.865 607.683 677.47 606.927 677.739C606.172 678.007 605.777 678.837 606.045 679.592C625.027 733.023 630.396 790.341 621.666 846.367C621.542 847.159 622.084 847.901 622.877 848.025C623.669 848.148 624.411 847.606 624.534 846.814C633.339 790.311 627.924 732.505 608.781 678.621Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.2 528.942C333.152 514.235 312.979 508.642 298.807 515.856C284.635 523.07 277.155 540.074 278.33 555.932C279.505 571.79 288.103 586.353 299.181 597.76C303.146 601.844 307.673 605.725 313.181 607.139C318.689 608.553 325.376 606.804 328.12 601.817C332.859 593.205 320.831 582.659 311.674 586.234C302.517 589.809 299.051 601.684 301.53 611.196C304.009 620.708 310.803 628.396 317.254 635.813C323.705 643.23 330.254 651.232 332.054 660.895C333.854 670.558 329.013 682.182 319.443 684.429C311.643 686.26 303.949 681.567 297.304 677.088",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.87 646.976L276.358 635.921",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.86 646.132L284.027 636.826",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.66 552.7L325.93 545.528",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.881 556.8L316.709 544.506",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.924 543.736C785.099 559.867 777.652 588.018 786.04 611.346C788.01 616.825 790.9 622.189 795.529 625.721C800.158 629.253 806.809 630.568 811.911 627.762C821.142 622.686 818.592 606.662 808.911 602.52C799.23 598.378 787.419 604.456 782.359 613.696C777.299 622.936 777.659 634.226 779.889 644.522C783.471 661.059 791.4 676.297 796.706 692.364C802.012 708.431 804.528 726.57 797.351 741.892C790.174 757.214 770.485 767.401 755.53 759.485C749.663 756.379 744.914 749.835 746.449 743.377C747.984 736.919 758.017 733.74 761.574 739.345",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.176 383.112C134.776 382.736 128.804 387.351 126.116 393.176C123.428 399.001 123.524 405.758 124.731 412.058C126.387 420.396 129.84 428.273 134.848 435.142C139.856 442.011 146.299 447.707 153.731 451.834C159.193 454.817 165.699 456.925 171.597 454.934C177.495 452.943 181.621 445.377 178.203 440.176C173.736 436.402 166.248 437.963 162.723 442.629C159.198 447.295 159.288 454.016 161.836 459.279C164.384 464.542 169.023 468.523 174.012 471.579C180.394 475.485 187.827 478.379 192.112 484.515C196.397 490.651 194.744 501.498 187.358 502.694L188.982 500.45",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.977 494.987L142.539 481.327",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.657 496.228L129.99 484.328",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8 456.738H249.09",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.9 447.152L239.457 469.014",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.422 748.387C176.405 745.246 174.283 741.355 173.275 737.117",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.177 748.387L181.471 739.166",
    stroke: "#171717",
    strokeWidth: 2.903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.624 175.454C456.031 195.572 453.413 216.654 449.81 237.204C446.243 257.554 442.752 277.916 439.337 298.292C432.369 339.375 425.477 380.47 418.661 421.576C411.926 462.385 405.342 503.185 398.538 543.976C391.666 585.176 387.738 626.817 380.498 667.986C372.363 714.228 364.571 760.543 355.773 806.663C354.601 812.809 364.18 815.285 365.085 809.23C371.299 767.664 378.385 726.23 385.185 684.757C388.53 664.376 392.31 644.093 396.105 623.792C399.893 603.532 404.758 583.509 408.74 563.299C412.798 542.699 415.654 521.86 419.173 501.168C422.686 480.508 426.88 459.937 430.495 439.282C437.676 398.258 444.77 357.219 451.775 316.166C455.695 293.166 459.664 270.176 463.457 247.156C467.276 223.979 472.411 200.574 473.957 177.12C474.431 169.94 463.482 168.751 461.619 175.451L461.624 175.454Z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.444 602.585C474.231 602.842 462.467 608.32 452.578 613.244C442.566 618.174 433.213 624.343 424.741 631.606C407.826 646.244 394.241 666.413 389.711 688.532C381.736 727.5 403.9 774.9 446.834 779C468.07 781.026 490.822 772.113 503.141 754.379C505.583 750.864 503.787 745.579 500.299 743.541C496.261 741.179 492.021 742.941 489.46 746.383C480.66 758.215 465.228 763.734 450.86 763.368C435.093 762.968 422.06 754.114 413.904 740.88C405.204 726.752 401.654 709.069 404.994 692.749C408.734 674.473 419.082 657.978 432.437 645.158C440.202 637.781 448.877 631.424 458.252 626.242C463.08 623.542 468.083 621.11 473.052 618.694C477.998 616.294 483.286 614.71 487.908 611.674C491.781 609.13 490.508 602.474 485.447 602.59L485.444 602.585Z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.906 510.577C534.45 513.207 530.4 519.015 525.177 522.301C519.726 525.687 513.654 527.949 507.316 528.957C504.816 529.386 502.349 532.557 502.623 535.12C503.539 543.659 504.307 552.228 503.877 560.82C503.655 565.192 503.152 569.545 502.369 573.852C501.649 577.835 500.503 582.099 501.007 586.138C501.415 589.413 505.832 592.593 508.529 589.254C514.243 582.177 514.934 571.409 515.843 562.654C516.945 552.922 516.721 543.087 515.178 533.416L510.714 541.278C518.251 539.557 525.397 536.429 531.774 532.059C537.211 528.265 545.002 522.294 546.174 515.39C546.369 514.577 546.324 513.725 546.045 512.937C545.766 512.149 545.265 511.459 544.603 510.949C543.94 510.44 543.144 510.133 542.311 510.066C541.478 509.999 540.644 510.175 539.908 510.572L539.906 510.577Z",
    fill: "#171717"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_248_1695",
    x1: 442.363,
    y1: 173.056,
    x2: 442.363,
    y2: 810.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_248_1695",
    x1: 671.866,
    y1: 827.474,
    x2: 671.866,
    y2: 868.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_248_1695",
    x1: 606.56,
    y1: 868.378,
    x2: 606.56,
    y2: 920.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_248_1695",
    x1: 478.648,
    y1: 595.795,
    x2: 478.648,
    y2: 780.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A67F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_1695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 716,
    height: 883,
    fill: "white",
    transform: "translate(122 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalNomad);
export default __webpack_public_path__ + "static/media/digital_nomad.e9db75d01701eec1beebf1f3265b1771.svg";
export { ForwardRef as ReactComponent };